import React from "react";
import MapContainer from "./MapContainer";
import "./About.css";
import MoreDetails from "./MoreDetails";

const About = () => {
  return (
    <div>
      <AboutText />
      <MapContainer />
      <MoreDetails/>
    </div>
  );
};
export default About;

const AboutText = () => {
  return (
    <div className="about-text cairo-font wrapper">
      <h1>عن المركز</h1>
      <p>
        مركز المهندس لصيانة السيارات هو مركز يستخدم احدث الأجهزة والمعدات
        الحديثة<br/> للكشف عن الأعطال وصيانة السيارات ويوجد بالمركز مهندسون وعمال على
        درجات خبرة عالية بمجال صيانة السيارات وستجد بالمركز كل ما يلزم سيارتك
        من كماليات او زيوت او غيره
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/about/About.js